<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.nodes') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20">
        <div class="section-title mb-20">
          <el-button
            type="success"
            plain
            class="common-btn"
            @click="addNode()"
            v-if="p('Devices.Node.Add')"
            >{{ $t('text.add_node').toUpperCase() }}</el-button
          >
          <span class="right-float">
            <svg-icon
              iconClass="filter"
              className="content-element-color-more-lighter"
            ></svg-icon>
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              :placeholder="$t('text.filter_node')"
            ></el-input>
          </span>
        </div>
        <el-table border :data="nodes" v-loading="loading" style="width: 100%">
          <el-table-column
            :label="$t('text.mac_address')"
            prop="MacAddress"
            fixed
            width="160"
          ></el-table-column>
          <el-table-column
            :label="$t('text.version') | firstLetterCapitalize"
            prop="FirmwareVersion"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.FirmwareVersion"
                :class="
                  scope.row.DeviceType === 'BLE_IOT'
                    ? !latestVersion ||
                      scope.row.FirmwareVersion.replace(
                        /^v/i,
                        ''
                      ).toLowerCase() ===
                        latestVersion.replace(/^v/i, '').toLowerCase()
                      ? 'blackish-green-font'
                      : 'red-font'
                    : 'blackish-green-font'
                "
                >{{ scope.row.FirmwareVersion }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.room')" width="230">
            <template slot-scope="scope">
              <div>
                {{ scope.row.BuildingName }}, {{ scope.row.FloorName }},
                {{ scope.row.RoomNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.connection_type')"
            prop="ConnectionType"
            width="150"
          ></el-table-column>
          <el-table-column
            :label="$t('text.device_role')"
            prop="DeviceRole"
          ></el-table-column>
          <el-table-column
            :label="$t('text.device_type')"
            prop="DeviceType"
          ></el-table-column>
          <el-table-column :label="$t('text.status')">
            <template slot-scope="scope">
              <el-tag :type="scope.row.IsOnline ? 'success' : 'danger'">
                {{
                  scope.row.IsOnline ? $t('text.online') : $t('text.offline')
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.action')"
            v-if="p('Devices.Node.Delete') || p('Devices.Node.Edit')"
          >
            <template slot-scope="scope">
              <div
                class="blue-font underline pointer inline-block mr-10"
                v-if="
                  p('Devices.Node.Edit') && scope.row.DeviceType === 'BLE_IOT'
                "
                @click="editRow(scope.row)"
              >
                {{ $t('text.edit') | firstLetterCapitalize }}
              </div>
              <div
                class="red-font underline pointer inline-block"
                v-if="
                  p('Devices.Node.Delete') && scope.row.DeviceType === 'BLE_IOT'
                "
                @click="deleteRow(scope.row)"
              >
                {{ $t('text.delete') | firstLetterCapitalize }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <AddNode ref="addNode" />
  </div>
</template>

<script>
import AddNode from '@/components/nodes/AddNode'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      filter: '',
      nodes: [],
      timer: '',
      latestVersion: null
    }
  },
  components: {
    AddNode
  },
  mounted() {
    this.getLatestVersion()
    this.getData()
  },
  watch: {
    '$store.state.site.selectedSite.SiteId': function() {
      this.getData()
    },
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getLatestVersion() {
      ApiService.GetFwVerV2('node').then(response => {
        if (response.data.success) {
          this.latestVersion = response.data.data.version
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    getData() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.nodes = []
      this.loading = true
      ApiService.getSiteNodes(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.loading = false
        if (response.data.success) {
          this.nodes = response.data.data
          if (this.filter) {
            this.nodes = this.nodes.filter(item => {
              return (
                item.MacAddress.toLowerCase().indexOf(
                  this.filter.toLowerCase()
                ) > -1 ||
                item.RoomNumber.toLowerCase().indexOf(
                  this.filter.toLowerCase()
                ) > -1
              )
            })
          }
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    addNode() {
      this.$refs.addNode.openDialog()
    },
    deleteRow(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_node_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') + ' ' + item.MacAddress,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDelete(item)
        })
        .catch(() => {})
    },
    handleDelete(item) {
      this.loading = true
      ApiService.DeleteSiteNode(item.OrganisationId, item.MacAddress).then(
        response => {
          this.loading = false
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        }
      )
    },
    editRow(item) {
      this.$refs.addNode.openDialog(item)
      this.$nextTick(() => {
        this.$refs.addNode.form = {
          NodeId: item.NodeId,
          MacAddress: item.MacAddress,
          RoomId: item.RoomId.toLowerCase()
        }
      })
    }
  }
}
</script>
